import { render } from "./patient-list.vue?vue&type=template&id=5bc58125"
import script from "./patient-list.vue?vue&type=script&lang=js"
export * from "./patient-list.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__